import React from 'react'
import { Routes, Route } from "react-router-dom";


export default function AnonyLayout(props) {
    let components = []
    props?.menus?.forEach((menu) => {
        components.push(menu)
        if (menu?.submenus) {
            menu?.submenus?.forEach((submenu) => {
                components.push(submenu)
            })
        }
    })

    return (
        <>
            <Routes>
                {
                    components?.map((menu, j) => <Route key={j} path={menu.to} element={menu.component} />)
                }
            </Routes>

        </>
    )
}
